import o from "./index.es208.js";
function r() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = e.images, t = a === void 0 ? [] : a, s = e.sheetId;
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' + t.map(function(n, i) {
    return '<Relationship Id="rId'.concat(i + 1, '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/').concat(o(n, {
      sheetId: s,
      sheetImages: t
    }), '"/>');
  }).join("") + "</Relationships>";
}
export {
  r as default
};
//# sourceMappingURL=index.es214.js.map
